// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"8992007d","131":"6e3d1a82","137":"2a8bf98a","150":"343cc65f","204":"bdbf0658","285":"5d6f49fa","418":"45a7b4f0","475":"af84f4be","593":"06d32336","747":"9540a05f","794":"8a971171","936":"9ba0f318","967":"ead37e50"}[chunkId] + ".chunk.js";
};